<template>
    <div>
        <div class="container-fluid steps-wave-top  mt-5" v-if="course && course.step_1"></div>
        <div class="container-fluid steps-blue-bg"
             v-if="course && course.step_1">
            <div class="container pt-5">
                <div class="row">
                    <div class="col-12 col-lg-2 step-step-1">
                        <div class="step-title">
                            {{ $t('Step') }} 1
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_1 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 step-step-2">
                        <div class="step-title">
                            {{ $t('Step') }} 2
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_2 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 step-step-3">
                        <div class="step-title">
                            {{ $t('Step') }} 3
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_3 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 step-step-4">
                        <div class="step-title">
                            {{ $t('Step') }} 4
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_4 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 step-step-5">
                        <div class="step-title">
                            {{ $t('Step') }} 5
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_5 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 step-step-6 d-lg-block d-none">
                        <div class="step-title">
                            {{ $t('Step') }} 6
                        </div>
                        <div class="step-text">
                            <vue-markdown-lite>{{ course.step_6 }}</vue-markdown-lite>
                        </div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
        <div class="container-fluid steps-wave-bottom" v-if="course && course.step_1"></div>

    </div>
</template>

<script>
    import VueMarkdownLite from '@earthtone/vue-markdown-lite'

    export default {
        name: 'CourseSteps',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        components: {
            VueMarkdownLite
        },

        data() {
            return {}
        },

        mounted() {
        },

    }
</script>
<style>

    .step-text p {
        color: #4f4d5c;
        font-size: 17.5px;
        line-height: 24px;
    }

    .step-text p strong {
        font-family: "Manrope Bold";
    }
</style>

<style scoped>

    .steps-blue-bg {
        background-color: #f2f6f8;
        background-position: center;
        background-repeat: no-repeat;
    }

    .step-title {
        color: #5ab947;
        font-size: 18px;
        font-family: "Manrope Bold";
        margin-bottom: 10px;
    }

    .steps-wave-top {
        background-image: url('~@/assets/poliglotiki/images/steps-blue-wave-top.png');
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
        height: 17px;
    }

    .steps-wave-bottom {
        background-image: url('~@/assets/poliglotiki/images/steps-blue-wave-bottom.png');
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
        height: 22px;
    }

    @media (min-width: 992px) {
        .steps-blue-bg {
            background-image: url('~@/assets/poliglotiki/images/steps-lg.png');
            height: 485px;
        }

        .step-step-1, .step-step-3, .step-step-5 {
            margin-top: 105px;
        }

        .step-step-2, .step-step-4, .step-step-6 {
            margin-top: 160px;
        }
    }

    @media (min-width: 1920.1px) {
        .steps-wave-top {
            background-size: 100% 17px;
        }

        .steps-wave-bottom {
            background-size: 100% 22px;
        }
    }

    @media (max-width: 991.8px) {
        .steps-wave-top, .steps-wave-bottom {
            background-size: cover;
        }

        .steps-blue-bg {
            background-image: url('~@/assets/poliglotiki/images/steps-sm.png');
            height: 1015px;
            background-position: center 71px;
        }

        .steps-blue-bg .row {
            width: 330px;
            margin: 0 auto;
            position: relative;
        }

        .step-step-1, .step-step-2, .step-step-3, .step-step-4, .step-step-5, .step-step-6 {
            position: absolute;
            margin-left: 40px;
            padding-right: 130px;
        }

        .step-step-1 {
            top: 49px;
        }

        .step-step-2 {
            top: 229px;
        }

        .step-step-3 {
            top: 408px;
        }

        .step-step-4 {
            top: 589px;
        }

        .step-step-5 {
            top: 764px;
        }

        .step-step-6 {
            top: 600px;
        }
    }
</style>
